module.exports = "img/15.7dea1c.webp";